module.exports = __webpack_public_path__ + "img/mvtn.367bc7d8.svg";